// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

const Banner = styled.img`
  width: 100%;
`;

class BannerLateral extends PureComponent {
  props: {
    pageInfo: Object,
  }

  render() {
    const { pageInfo = {} } = this.props;
    const { page = {} } = pageInfo;
    return (
      <a href={page.left_banner_url} target="_blank">
        <Banner
          src={`http://cl.verinmuebles.com/microsite/presentation/${page.left_banner}`}
        />
      </a>
    );
  }
}

export default connect(state => ({
  pageInfo: state.client.pageInfo,
}))(BannerLateral);


// WEBPACK FOOTER //
// ./src/components/HomeLayout/BannerLateral/index.js